<template>
  <div :class="selected_class + ' select'" :style="{ width: width + 'px' }" ref="option">
    <a href="javascript:;" class="defaultText" @click="toggle">{{ selected_text }}</a>
    <transition name="gas-select">
      <div :class="'anotherlayer ' + optionStyle" v-show="is_show">
        <ul>
          <li v-for="(option, index) in options_new" :key="index" @click="choice(option)">
            <a
              href="javascript:;"
              :value="Object.values(option)[0]"
              :name="Object.values(option)[data_index]"
              >{{ option.text || Object.values(option)[data_index] }}</a
            >
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "select-single",
  props: {
    value: [Number, String],
    text: String,
    width: Number,
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    optionStyle: {
      type: String,
      default: "cliquelayer",
    },
  },
  data() {
    return {
      selected_text: this.text,
      selected_class: "selected",
      data_index: 1, // 文本数据位置
      is_show: false,
    };
  },
  computed: {
    options_new() {
      if (Object.keys(this.options).length > 0) {
        return JSON.parse(JSON.stringify(this.options));
      }
      return {};
    },
  },
  watch: {
    options_new(new_val, old_val) {
      this.data_index = typeof Object.values(new_val[0])[1] === "string" ? 1 : 2;
      if (
        JSON.stringify(new_val) !== JSON.stringify(old_val) &&
        JSON.stringify(old_val) !== "{}"
      ) {
        this.selected_text = this.text;
        this.$emit("input", 0);
      }
      if (JSON.stringify(old_val) === "{}") {
        // 初始化参数文本
        if (new_val.filter((item) => Object.values(item)[0] == this.value).length !== 0)
          this.selected_text = Object.values(
            new_val.filter((item) => Object.values(item)[0] == this.value)[0]
          )[this.data_index];
      }
    },
  },
  mounted() {
    document.addEventListener("click", (e) => {
      if (this.$refs.option) {
        if (!this.$refs.option.contains(e.target)) {
          this.hide();
        }
      }
    });
  },
  methods: {
    toggle() {
      this.is_show = !this.is_show;
    },
    choice(option) {
      let choiced_value = option.value || Object.values(option)[0];
      this.value = choiced_value;
      console.log(choiced_value)
      this.selected_text = option.text || Object.values(option)[this.data_index];
      // this.selected_class = this.selected_text === this.text ? '' : 'selected';  选项置灰
      this.$emit("input", option.value || Object.values(option)[0]);
      this.$emit("reset");
      this.hide();
    },
    hide() {
      this.is_show = false;
    },
  },
};
</script>

<style scope>
.gas-select-enter-active,
.gas-select-leave-active {
  transition: all 0.3s ease;
}
.gas-select-enter,
.gas-select-leave-to {
  opacity: 0;
  transform: translateY(5px);
}
</style>
